<div class="recap-container">
  <div class="recap flex-row justify-between">
    <div class=" flex-row font-weight-500 text-color-dark-blue font-size-14 text-left pt-8">
      <div class="justify-start">
        <span>
          @if (dataRecap.direction=='FORWARD'||fw) {
            <span class="label">ANDATA </span>
          }
          @if (dataRecap.direction=='RETURN' && !fw) {
            <span class="label">RITORNO </span>
          }
        {{dataRecap.start.name}}</span>
        <span> <mat-icon style="vertical-align: middle">chevron_right</mat-icon> </span>
        <span>{{dataRecap.end.name}} - </span>
        <span>{{dataRecap.departure| date: 'd/M/y H:mm'}}  </span>
        @if (dataRecap.arrive) {
          <span> - {{dataRecap.arrive | date: 'H:mm'}} </span>
        }
        <!-- inline-flex, non fx-row: display:flex renderebbe lo span un box
        block-level dentro un flusso inline, spezzando il recap su piu' righe -->
        <span style="display:inline-flex; align-items:center; gap:8px; font-weight: 600">
          <span style="font-weight: 500"> | {{dataRecap.adult}} ADT</span>
          @if (dataRecap.children>0) {
            <span style="font-weight: 500">, {{dataRecap.children}} RGZ </span>
          }
        </span>
        @if (dataRecap.tot>0) {
          <span>
            <span> |
              @if (!['RETURN','FORWARD'].includes(dataRecap.direction)) {
                <span class="total"
                  matTooltip="{{dataRecap.fee>0?'Prezzo:'+(dataRecap.totNet| currency:'EUR':'symbol':'1.2-2')+' + Diritti agenzia:'+(dataRecap.fee| currency:'EUR':'symbol':'1.2-2'):''}}">
                  Totale: {{dataRecap.tot | currency:'EUR':'symbol':'1.2-2' }}
                </span>
              }
              @if (['RETURN','FORWARD'].includes(dataRecap.direction)) {
                <span class="total"
                  matTooltip="{{dataRecap.fee>0?'Prezzo:'+(dataRecap.totNet| currency:'EUR':'symbol':'1.2-2')+' + Diritti agenzia:'+(dataRecap.fee| currency:'EUR':'symbol':'1.2-2'):''}}">
                {{dataRecap.tot | currency:'EUR':'symbol':'1.2-2' }}</span>
              }
            </span>
          </span>
        }
        @if (dataAv) {
          <mat-icon class="open-details" (click)="onShowDetails()">{{showDetails?'keyboard_arrow_up':'keyboard_arrow_down'}}</mat-icon>
        }
      </div>
    </div>
    <div class="flex-row">
      <div class="justify-end">
        <!--<mat-icon class="open-details" (click)="trnService.btnAction.next('back')" *ngIf="dataAv" [matTooltip]="'Modifica'">edit</mat-icon>-->
        @if (dataAv && (trnService.step.value > 2||fw)) {
          <button mat-raised-button
            [disabled]="trnService.loading.value" (click)="fw?trnService.btnAction.next('back-fw'):trnService.btnAction.next('back')">
            Modifica
            <mat-icon iconPositionEnd>edit</mat-icon>
          </button>
        }
      </div>
    </div>


  </div>
  @if (showDetails) {
    @for (tr of trains; track tr; let last = $last) {
      <div class="train-info">
        <div class="flex-row flex-gap-20">
          <mat-icon>train</mat-icon>
          <trenitalia-train-breadcrumbs [trains]="[tr]"></trenitalia-train-breadcrumbs>
          <div >
            <span class="tr-time">{{tr.departure | date:'HH:mm'}}</span>
          </div>
          <div >
            {{tr.start.stationName}}
          </div>
          <div >
            <mat-icon class="arr">keyboard_arrow_right</mat-icon>
          </div>
          <div >
            <span class="tr-time">{{tr.arrival | date:'HH:mm'}}</span>
          </div>
          <div >
            {{tr.end.stationName}}
          </div>
        </div>
        <div class="train-tickets-container flex-col">
          @if (dataRecap.details && dataRecap.details[tr.id]) {
            @for (ticket of dataRecap.details[tr.id].tickets; track ticket) {
              <div>
                <div class="train-ticket flex-row  flex-gap-8 justify-start">
                  <div>
                    <div><strong>{{ticket.offerName}} / {{ticket.catalogServiceName}} @if (ticket.position) {
                      <span> - {{ticket.position}} </span>
                    }</strong> </div>
                    @if (ticket.traveller) {
                      <div>{{ticket.traveller.type}}</div>
                    }
                  </div>
                  <div>
                    @if (ticket.seatInfo && ticket.seatInfo.seat !== '999') {
                      <div class="fx-row" style="gap: 8px">
                        <span matTooltip="Vagone" class="train-ticket-seat">
                          <mat-icon>train</mat-icon>
                          {{ticket.seatInfo.wagon}}
                        </span>
                        <span matTooltip="Posto" class="train-ticket-seat">
                          <mat-icon>event_seat</mat-icon>
                          {{ticket.seatInfo.seat}}
                        </span>
                      </div>
                    }
                  </div>
                  @if (ticket.prices) {
                    <div class="train-ticket-price" style="text-align: center;">
                      <span  class="font-weight-700" matTooltip="{{ticket.prices.fee>0?'Prezzo:'+(ticket.prices.netPrice| currency:'EUR':'symbol':'1.2-2')+' + Diritti agenzia:'+(ticket.prices.fee | currency:'EUR':'symbol':'1.2-2'):''}}">
                        {{ticket.prices.price | currency:'EUR':'symbol':'1.2-2'}}
                      </span>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </div>
        @if (!last) {
          <mat-divider></mat-divider>
        }
      </div>
    }
  }
</div>